/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Collections_DescriptionInputs */



/**
* | output |
* | --- |
* | "Organize cards by where they physically are (deck boxes, binders, or lent to friends) and control which are available for deck building." |
*
* @param {Help_Article_Collections_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_collections_description = /** @type {((inputs?: Help_Article_Collections_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Collections_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sortiere Karten danach, wo sie physisch liegen (Deckboxen, Ordner oder an Freunde verliehen), und steuere, welche für den Deckbau verfügbar sind.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organisez vos cartes selon leur emplacement physique (deck boxes, classeurs ou prêtées à des amis) et choisissez lesquelles sont disponibles pour la construction de decks.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("按卡牌实际存放的位置（卡盒、卡册，或借给朋友）来整理，并控制哪些卡牌可用于构筑卡组。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("依卡牌實際存放的位置整理（牌盒、卡冊，或借給朋友），並控制哪些卡牌可用於組牌。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드가 실제로 있는 곳(덱 박스, 바인더, 친구에게 빌려준 카드)에 따라 정리하고, 덱 구축에 쓸 카드를 지정하세요.")
	return /** @type {LocalizedString} */ ("Organize cards by where they physically are (deck boxes, binders, or lent to friends) and control which are available for deck building.")
});